<div class="relative">
  <input
    #inputRef
    tabindex="0"
    [value]="value() || null"
    class="px-3 py-2.5 text-sm font-medium text-gray-800 border border-gray-300 placeholder:text-gray-400 placeholder:font-normal placeholder:text-sm focus:border-none ring-primary focus:ring-2"
    [placeholder]="placeholder() || '검색어를 입력해주세요.'"
    [spellcheck]="spellcheck()"
    [autocomplete]="autocomplete()"
    [autofocus]="autofocus()"
    [readOnly]="readonly()"
    [maxLength]="maxlength() || 524288"
    (click)="inputClick.emit()"
    (focus)="inputFocus.emit()"
    (blur)="inputBlur.emit()"
    (paste)="handlePaste($event)"
    type="text"
    [ngClass]="[width() || 'xl:min-w-[283px]', round() || 'rounded-xl']"
  />

  @if(icon()){
  <app-icon
    id="searchIcon"
    (click)="search()"
    name="material-symbols:search"
    class="absolute z-10 block pb-0.5 -translate-y-1/2 cursor-pointer right-3 top-1/2 text-gray-400 hover:opacity-80"
    size="sm"
  />
  }
</div>
